import React from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import PublicationEditRoutes from './routes'

const PublicationEdit = () => {
  const { publicationId } = useNumericParams()

  useReduxAction(
    'publications',
    'loadPublication',
    {
      entityId: publicationId,
      ...defaultRequestOptions.publication,
      include_publication_provider: true,
      include_provider_logo: true,
    },
    [publicationId],
    {
      dispatchAction: (action, requestOptions) => action(publicationId, requestOptions),
      shouldPerformFn: ({ loading }) => publicationId && !loading,
    },
  )

  return (
    <PublicationEditRoutes />
  )
}

export default PublicationEdit
